import { accountConstants } from "../_constants";

export function account(
  state = { accountFetchingDetail: false, accountDetail: {}, accountTab: "energy" },
  action
) {
  switch (action.type) {
    case accountConstants.ENERGY_DETAIL_REQUEST:
      return {
        ...state,
        accountFetchingDetail: true
      };
    case accountConstants.ENERGY_DETAIL_SUCCESS:
      let obj = action.detail;

      if (obj.length === 2) {
        return {
          ...state,
          accountFetchingDetail: false,
          accountDetail: obj
        };
      } else {
        if (action.detail[0].dashboard_type === 2) {
          obj = {
            [0]: {},
            [1]: action.detail[0]
          };
        }
        if (action.detail[0].dashboard_type === 1) {
          obj = {
            [0]: action.detail[0],
            [1]: {}
          };
        }

        return {
          ...state,
          accountFetchingDetail: false,
          accountDetail: obj
        };
      }
    case accountConstants.ENERGY_DETAIL_FAILURE:
      return {
        ...state
      };
    case accountConstants.SUBMIT_REQUEST:
      return {
        ...state
      };
    case accountConstants.SUBMIT_SUCCESS:
      return {
        ...state
      };
    case accountConstants.SUBMIT_FAILURE:
      return {
        ...state
      };
    case accountConstants.SUBMIT_ALERT_REQUEST:
      return {
        ...state
      };
    case accountConstants.SUBMIT_ALERT_SUCCESS:
      return {
        ...state
      };
    case accountConstants.SUBMIT_ALERT_FAILURE:
      return {
        ...state
      };
    case accountConstants.SUBMIT_EMAIL_REQUEST:
      return {
        ...state
      };
    case accountConstants.SUBMIT_EMAIL_SUCCESS:
      return {
        ...state
      };
    case accountConstants.SUBMIT_EMAIL_FAILURE:
      return {
        ...state
      };
    case accountConstants.TOGGLE_TAB:
      return {
        ...state,
        accountTab: action.detail
      };
    default:
      return state;
  }
}
